export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-bold">
        <strong>No data stored on servers. All calculations run in your browser.</strong>
      </p>
      <p className="footer-sub">
        This is a planning tool, not a credit score. It's here to help you see your options more clearly.
      </p>
      <p className="footer-sub">
        Privacy by Design • Built with <span aria-hidden="true">❤️</span> • v2.0.0
      </p>
      <p className="footer-sub">
        Guides:{' '}
        <a href="/learn/financial-runway" className="footer-link">Financial runway calculator</a>
        {' '}
        ·{' '}
        <a href="/learn/emergency-fund" className="footer-link">How many months of emergency fund?</a>
        {' '}
        ·{' '}
        <a href="/learn/safe-emi-percentage" className="footer-link">What is a safe EMI percentage?</a>
        {' '}
        ·{' '}
        <a href="/learn/build-3-month-buffer" className="footer-link">How to build a 3-month buffer</a>
      </p>
    </footer>
  );
}
